/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { errorIcon, successIcon, warningIcon } from "utils/constant";

interface StatusTooltipProps {
  header?: string;
  message: string;
  type?: "success" | "error" | "info";
  onClose: () => void; // Callback to close the tooltip
  duration?: number; // Duration in milliseconds before auto-closing
}

const StatusTooltip: React.FC<StatusTooltipProps> = ({
  type = "info",
  header = type === "success"
    ? "Successful"
    : type === "error"
    ? "Error"
    : "Information",
  message,
  onClose,
  duration = 3000,
}) => {
  const [showTooltip, setShowTooltip] = useState(true);
  const timerRef = useRef<number | null>(null); // Use number for `setTimeout` in TypeScript

  useEffect(() => {
    startTimer();

    return () => {
      clearTimer(); // Cleanup timer on unmount
    };
  }, [onClose, duration]);

  const startTimer = () => {
    clearTimer(); // Clear any existing timer before starting a new one
    timerRef.current = window.setTimeout(() => {
      setShowTooltip(false);
      onClose(); // Automatically close the tooltip after the duration
    }, duration);
  };

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const stopTimer = () => {
    clearTimer(); // Stop the timer when hovering
  };

  const getBorderColor = () => {
    switch (type) {
      case "success":
        return "border border-l-[10px] border-[#198754]";
      case "error":
        return "border border-l-[10px] border-[#CC362F]";
      case "info":
      default:
        return "border border-l-[10px] border-[#EED116]";
    }
  };
  const getHeaderColor = () => {
    switch (type) {
      case "success":
        return "text-[#198754]";
      case "error":
        return "text-[#CC362F]";
      case "info":
      default:
        return "text-[#B29C10]";
    }
  };

  return showTooltip ? (
    <div
      className={`fixed flex items-start justify-between top-4 right-4 px-4 py-2 bg-white rounded shadow-lg ${getBorderColor()} w-[400px] `}
      onMouseEnter={stopTimer} // Stop the timer on hover
      onMouseLeave={startTimer} // Resume the timer when hover ends
    >
      <div>
        <p
          className={`font-[Poppins] font-bold flex flex-row items-center gap-2 text-lg ${getHeaderColor()} `}
        >
          {type === "success"
            ? successIcon
            : type === "error"
            ? errorIcon
            : type === "info"
            ? warningIcon
            : ""}{" "}
          {header}
        </p>
        <p className="text-[#555555] text-normal">{message}</p>
      </div>
      {/* <button
        onClick={() => {
          clearTimer(); // Clear the timer when manually closing
          setShowTooltip(false);
          onClose();
        }}
        className="ml-4 text-white hover:text-gray-200 focus:outline-none"
        aria-label="Close"
      >
        ×
      </button> */}
    </div>
  ) : null;
};

export default StatusTooltip;
